import { Box, Typography, Grid } from '@mui/material'
import { blue, grey } from '@mui/material/colors'
import React from 'react'

import T from 'T'

import { legendItemStyles, legendColorBoxStyles, SELECTION_COLORS, BILLING_STATUS_COLORS, EVENT_BADGE_COLOR } from './styles'

const LEGEND_ITEMS = [
  {
    label: T.TODAYS_DATE,
    color: 'transparent',
    borderColor: blue[500],
    borderWidth: 2,
  },
  {
    label: T.UNBILLED,
    color: BILLING_STATUS_COLORS.UNBILLED,
  },
  {
    label: T.START_DATE,
    color: SELECTION_COLORS.START_DATE,
  },
  {
    label: T.BILLED,
    color: BILLING_STATUS_COLORS.BILLED,
  },
  {
    label: T.END_DATE,
    color: SELECTION_COLORS.END_DATE,
  },
  {
    label: T.GRACE_PERIOD,
    color: BILLING_STATUS_COLORS.GRACE_PERIOD,
  },
  {
    label: T.END_START_DATE,
    color: SELECTION_COLORS.END_DATE,
    isSplit: true,
    splitColor: SELECTION_COLORS.START_DATE,
  },
  {
    label: T.EVENT,
    color: EVENT_BADGE_COLOR,
    isEvent: true,
  },
]

const RentalFeeCalendarLegend = () => {
  return (
    <Box
      sx={{
        p: 1.5,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        backgroundColor: grey[50],
      }}
    >
      <Typography fontWeight={600} sx={{ mb: 1, display: 'block' }} variant="caption">
        {T.CALENDAR_LEGEND}
      </Typography>
      <Grid container spacing={1}>
        {LEGEND_ITEMS.map(item => (
          <Grid
            key={item.label}
            size={{
              xs: 6,
            }}
          >
            <Box sx={legendItemStyles}>
              {item.isEvent ? (
                <Box
                  sx={{
                    width: 16,
                    height: 16,
                    borderRadius: '50%',
                    backgroundColor: item.color,
                  }}
                />
              ) : (
                <Box
                  sx={{
                    ...legendColorBoxStyles(item.color, item.isSplit, item.splitColor),
                    ...(item.borderColor && {
                      borderColor: item.borderColor,
                      borderWidth: item.borderWidth,
                    }),
                  }}
                />
              )}
              <Typography color="textSecondary" variant="caption">
                {item.label}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  )
}

export default RentalFeeCalendarLegend
